import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Button,
  Card,
  Checkbox,
  Form,
  Input,
  Radio,
  Select,
  message,
  Divider,
  Row,
  Col,
  Typography,
  Slider,
  InputNumber,
  Switch,
  Modal,
  Upload,
  Tabs
} from 'antd';
import { useFetchPageData, usePageData } from '../../../hooks/usePage';
import { IAppointment } from '../../../interfaces/patient';
import { IPageData } from '../../../interfaces/page';
import Moment from 'react-moment';
import apiAdmin from '../../../services/administracionProvider';
import apiSalud from '../../../services/saludProvider';
import jwt_decode from 'jwt-decode';
import { navegarABandeja } from '../../../utils/navegar-bandeja';
import seguridadProvider from '../../../services/seguridadProvider';
import { DownloadOutlined, UploadOutlined } from '@ant-design/icons';
import { Bitacora } from './bitacora/bitacora';
import { navigateHome } from '../../../utils/naviagate-home';
import administracionProvider from '../../../services/administracionProvider';
import { saveAs } from 'file-saver';

const { Text } = Typography;
const { Option } = Select;
const { TabPane } = Tabs;

const pageData: IPageData = {
  fulFilled: true,
  breadcrumbs: [
    {
      title: 'Sintomatologia COVID-19',
      route: 'sintomatologia-covid19'
    },
    {
      title: 'Covid - 19'
    }
  ]
};

const key = 'regitrando';

const LecturaFicha = () => {
  const location: any = useLocation();
  const token: any = jwt_decode(localStorage.getItem('token'));
  const usr: any = JSON.parse(token.data);
  usePageData(pageData);
  const [cargando, setCargando] = useState(false);
  const [cargandoContacto, setCargandoContacto] = useState(false);
  const [adjuntos, setAdjuntos] = useState([]);
  const [lecturaFicha, setLecturaFicha] = useState({
    id: 0,
    codigo: '',
    nombreApellido: '',
    estadoId: 0,
    CercaniaCovid: false,
    enfermedadesRelacionadas: '',
    adjuntos: []
  });
  const [empresas, setEmpresas] = useState([]);
  const [mostrarRegistrarUsuario, setMostrarRegistrarUsuario] = useState(false);
  const [cargandoRegistrarUsuario, setCargandoRegistrarUsuario] = useState(false);
  const [radioValue1, setRadioValue1] = useState(2);
  const [radioValue2, setRadioValue2] = useState(2);
  const handleRadioChange1 = (e) => setRadioValue1(e.target.value);
  const handleRadioChange2 = (e) => setRadioValue2(e.target.value);
  const [usuario, setUsuario] = useState(usr);
  const obtenerEmpresas = async () => {
    const response: any = await apiAdmin.obtenerEmpresas();
    setEmpresas(response);
  };
  const iniciarValores = (data) => {
    let val = {};
    let cuarentenax = 0;
    let descansox = 0;
    let criticidad = 0;
    if (data) {
      if (data.aislamiento7) {
        cuarentenax = 7;
        criticidad = 60;
      }
      if (data.aislamiento14) {
        cuarentenax = 14;
        criticidad = 90;
      }
      val = {
        EmpresaId: data.empresaId,
        ruc: data.empresaRuc,
        NombreApellido: data.nombreApellido,
        Dni: data.dni,
        Direccion: data.direccion,
        Telefono: data.telefono,
        Fiebre: data.fiebre,
        Temperatura: data.temperatura,
        GustoPerdidaNivel: data.gustoPerdidaNivel === 0 ? null : data.gustoPerdidaNivel,
        FlemaTipo: data.flemaTipo,
        TosSeca: data.tosSeca,
        GustoPerdida: data.gustoPerdida,
        OlfatoPerdida: data.olfatoPerdida,
        Flema: data.flema,
        CercaniaCovid: data.cercaniaCovid === null ? false : data.cercaniaCovid,
        Medicacion: data.medicacion === null ? false : data.medicacion,
        MedicacionDescripcion: data.medicacionDescripcion,
        Terminos: data.terminos,
        RequiereEvaluacion: data.requiereEvaluacion,
        Observaciones: data.observaciones,
        Cuarentenax: cuarentenax,
        Criticidad: criticidad,
        Descansox: 0,
        RestriccionAcceso: data.aislamiento7 || data.aislamiento14
      };
    }
    form.setFieldsValue(val);
  };
  const obtenerFichaPorId = async (id) => {
    const response: any = await apiSalud.obtenerFichaPorId(id);
    if (response.succeeded) {
      iniciarValores(response.data);
      setLecturaFicha(response.data);
    }
  };

  const [form] = Form.useForm();

  useEffect(() => {
    obtenerEmpresas();
    if (location.state) {
      obtenerFichaPorId(location.state.id);
    } else {
      navigateHome();
      iniciarValores(null);
    }
  }, []);

  const handleOnFinish = async (val) => {
    if (lecturaFicha.id != 0) {
      val.Id = lecturaFicha.id;
      message.loading({ content: 'Calificando...', key });
      setCargando(true);
      const res: any = await apiSalud.guardarFicha(val).catch((err) => {
        setCargando(false);
        message.error(err.message);
      });
      if (res) {
        setCargando(false);
        message.success({
          content: 'Se Califico la ficha! (' + res.codigo + ')',
          key,
          duration: 5
        });
        form.resetFields();
        navegarABandeja();
      }
    } else {
      message.loading({ content: 'Registrando...', key });
      setCargando(true);
      val.EstadoId = 1;
      const res: any = await apiSalud.guardarFicha(val);
      if (res) {
        if (res.id === 0) {
          message.info({ content: 'No existe usuario', key, duration: 5 });
          setCargando(false);
          setMostrarRegistrarUsuario(true);
        } else {
          setCargando(false);
          message.success({ content: 'Ficha Registrada! (' + res.codigo + ')', key, duration: 5 });
          form.resetFields();
        }
      }
    }
  };

  const mostrarTitulo = () => {
    if (lecturaFicha.codigo != '')
      return `Ficha de Sintomatología COVID-19 (${lecturaFicha.codigo}).`;
    else return `Ficha de Sintomatología COVID-19.`;
  };

  const registrarUsuarioOk = async () => {
    setCargandoRegistrarUsuario(true);
    const usr = {
      usr: form.getFieldValue('Dni'),
      psw: '1234',
      nombres: form.getFieldValue('NombreApellido'),
      apellidos: '',
      dni: form.getFieldValue('Dni')
    };
    const res: any = await seguridadProvider.guardarUsuario(usr);
    setTimeout(() => {
      if (res.id != 0) {
        setMostrarRegistrarUsuario(false);
        setCargandoRegistrarUsuario(false);
        message.success({
          content: 'Se registro el usuario correctamente, ahora puede continuar con su ficha.',
          key,
          duration: 5
        });
      }
    }, 2000);
  };
  const registrarUsuarioCancel = () => {
    setMostrarRegistrarUsuario(false);
  };

  const desabilitarRegistrar = () => {
    return lecturaFicha.estadoId == 3 || lecturaFicha.estadoId == 4;
  };

  const buscarContacto = async (val) => {
    setCargandoContacto(true);
    const response: any = await seguridadProvider.obtenerContacto(val.currentTarget.value);
    setCargandoContacto(false);
    form.setFieldsValue({
      Referencia: response.contactoReferencia,
      TelefonoReferencia: response.telefonoReferencia,
      Direccion: response.direccion,
      Telefono: response.telefono
    });
  };

  const descargarArchivo = async (val) => {
    const adj: any = await administracionProvider.obtenerAdjuntoModel(val);
    const response = await administracionProvider.obtenerAdjunto(val);
    saveAs(response, adj.archivoOriginal);
  };

  const dibujarAdjuntos = (originNode, file, currFileList) => {
    return (
      <div className={'row'}>
        <div className='col-md-12' style={{ fontSize: '10px' }}>
          <Button type={'link'} onClick={() => descargarArchivo(file.id)}>
            <DownloadOutlined />
          </Button>{' '}
          {file.archivoOriginal}
        </div>
      </div>
    );
  };

  return (
    <>
      <Modal
        title='El Usuario no existe Desea registrarlo?'
        visible={mostrarRegistrarUsuario}
        onOk={registrarUsuarioOk}
        confirmLoading={cargandoRegistrarUsuario}
        onCancel={registrarUsuarioCancel}
      >
        <p>Es necesario registrar al usuario para poder dar seguimiento a su historia medica.</p>
      </Modal>
      {true ? null : (
        <Tabs tabPosition={'left'}>
          <TabPane tab='Ficha de Sintomatologia' key='1'>
            Ficha
          </TabPane>
          <TabPane
            tab='Evaluación'
            disabled={lecturaFicha.id != 0 && lecturaFicha.estadoId != 2}
            key='2'
          >
            Evaluacion
          </TabPane>
          <TabPane tab='Bitacora' key='3'>
            <Bitacora />
          </TabPane>
        </Tabs>
      )}
      <Card title={mostrarTitulo()}>
        <h5>
          He recibido explicación del objetivo de esta evaluación y me comprometo a responder con la
          verdad.
        </h5>
        <Form form={form} onFinish={handleOnFinish} labelAlign='left' layout='horizontal'>
          <div className='row'>
            <div className='col-md-8'>
              <Form.Item name='EmpresaId' label='Razón social:'>
                <Select placeholder='Seleccione Razón social'>
                  {empresas.map((p, index) => {
                    return (
                      <Option key={index} value={p.id}>
                        {p.nombre}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </div>
            <div className='col-md-4'>
              <Form.Item name='ruc' label='RUC:'>
                <Input disabled={true} placeholder='Ingrese Ruc..' />
              </Form.Item>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <Form.Item name='NombreApellido' label='Apellidos y Nombres:'>
                <Input allowClear={true} placeholder='Ingrese Apellidos y Nombres' />
              </Form.Item>
            </div>
            <div className='col-md-4'>
              <Form.Item
                name='Dni'
                validateStatus='validating'
                hasFeedback={cargandoContacto}
                label='DNI:'
              >
                <Input onPressEnter={buscarContacto} placeholder='Dni' id='validating' />
              </Form.Item>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <Form.Item name='Direccion' label='Ingresa tu dirección:'>
                <Input placeholder='Ingrese Dirección...' />
              </Form.Item>
            </div>
            <div className='col-md-4'>
              <Form.Item name='Telefono' label='Teléfono:'>
                <Input placeholder='Ingrese Telefono' />
              </Form.Item>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-8'>
              <Form.Item name='Referencia' label='Contacto referencia:'>
                <Input />
              </Form.Item>
            </div>
            <div className='col-md-4'>
              <Form.Item name='TelefonoReferencia' label='Telefono de referencia:'>
                <Input />
              </Form.Item>
            </div>
          </div>
          <div className='row'>
            <div className='col-md-12'>
              <table className='table table-bordered'>
                <thead>
                  <tr>
                    <th scope='col'>Pregunta(s)</th>
                    <th scope='col'>Respuesta(s)</th>
                    <th scope='col'>Detalle(s)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td style={{ verticalAlign: 'middle' }}>
                      ¿Haz tenido alguno de estos síntomas en los últimos 14 dias?
                    </td>
                    <td>
                      <Row>
                        <Col>
                          <Form.Item name='Fiebre' valuePropName='checked'>
                            <Checkbox>Sensación de alta térmica o fiebre.</Checkbox>
                          </Form.Item>
                          <Form.Item name='TosSeca' valuePropName='checked'>
                            <Checkbox>Tos, estornudos o dificultar para respirar.</Checkbox>
                          </Form.Item>
                          <Form.Item name='GustoPerdida' valuePropName='checked'>
                            <Checkbox>Pérdida del gusto.</Checkbox>
                          </Form.Item>
                          <Form.Item name='OlfatoPerdida' valuePropName='checked'>
                            <Checkbox>Pérdida del olfato.</Checkbox>
                          </Form.Item>
                          <Form.Item name='Flema' valuePropName='checked'>
                            <Checkbox>Expectoración de flema.</Checkbox>
                          </Form.Item>
                          <Divider />
                          <Checkbox>Ninguno</Checkbox>
                        </Col>
                      </Row>
                    </td>
                    <td>
                      <Form.Item name='Temperatura'>
                        <Select allowClear={true} placeholder='Temperatura'>
                          <Option value={1}>Menor a 37.5 C°</Option>
                          <Option value={2}>38 C°</Option>
                          <Option value={3}>38.5 C°</Option>
                          <Option value={4}>Mayor a 39 C°</Option>
                        </Select>
                      </Form.Item>
                      <br />
                      <br />
                      <Form.Item name='GustoPerdidaNivel'>
                        <Select allowClear={true} placeholder='Nivel'>
                          <Option value={5}>Ligera</Option>
                          <Option value={6}>Total</Option>
                        </Select>
                      </Form.Item>
                      <br />
                      <br />
                      <Form.Item name='FlemaTipo'>
                        <Select allowClear={true} placeholder='Tipo'>
                          <Option value={7}>Amarillenta</Option>
                          <Option value={8}>Verdosa</Option>
                        </Select>
                      </Form.Item>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      ¿Ha tenido contacto con alguna persona(s) con caso confirmado de COVID-19?
                    </td>
                    <td>
                      <Form.Item name='CercaniaCovid'>
                        <Radio.Group onChange={handleRadioChange1}>
                          <Radio value={true}>Si</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </td>
                    <td>
                      {form.getFieldValue('CercaniaCovid') ? (
                        <Upload
                          multiple={false}
                          showUploadList={{ showDownloadIcon: true }}
                          maxCount={1}
                          itemRender={dibujarAdjuntos}
                          defaultFileList={lecturaFicha.adjuntos}
                        >
                          <Button
                            type={'link'}
                            icon={<UploadOutlined />}
                            disabled={true}
                            onClick={null}
                          >
                            Subir prueba COVID-19
                          </Button>
                        </Upload>
                      ) : null}
                    </td>
                  </tr>
                  <tr>
                    <td>¿Esta tomando alguna medicación?</td>
                    <td>
                      <Form.Item name='Medicacion'>
                        <Radio.Group onChange={handleRadioChange2}>
                          <Radio value={true}>Si</Radio>
                          <Radio value={false}>No</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </td>
                    <td>
                      <Form.Item name='MedicacionDescripcion'>
                        <Input.TextArea placeholder='Descripción' rows={4} />
                      </Form.Item>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <br />
          <Form.Item
            name='Terminos'
            valuePropName='checked'
            rules={[
              {
                validator: (_, value) =>
                  value
                    ? Promise.resolve()
                    : Promise.reject('Es necesario aceptar las condiciones.')
              }
            ]}
          >
            <Checkbox>
              Declaro y acepto los datos expresados en esta ficha, constituyen declaración jurada de
              mi parte. He sido informado de omitir o declarar información falsa puedo perjudicar la
              salud de mis compañeros de trabajo, y la mia propia, asumiendo las responsabilidades
              que correspondan.
            </Checkbox>
          </Form.Item>
          <div className='row'>
            <div className='col-md-12'>
              <p>
                Lima, <Moment locale={'es'}>{Date.now()}</Moment>.
              </p>
            </div>
          </div>
          <br />
          {lecturaFicha.id != 0 && lecturaFicha.estadoId == 1 && (
            <>
              <Text style={{ color: 'green' }}>
                En base a las respuestas de la encuesta y la información configurada en el sistema,
                el trabajador no presenta riesgo de contagio.
              </Text>
              <br />
              <br />
            </>
          )}
          {lecturaFicha.id != 0 && lecturaFicha.estadoId == 2 && (
            <>
              <Text style={{ color: 'red' }}>
                En base a las respuestas de la encuesta y la información configurada en el sistema,
                el trabajador presenta riesgo de contagio. Las respuestas de la encuesta tambien
                coinciden con las siguientes sintomatologias:{' '}
                {lecturaFicha.enfermedadesRelacionadas}
              </Text>
              <br />
              <br />
            </>
          )}

          {lecturaFicha.id != 0 && lecturaFicha.estadoId == 2 && (
            <>
              <Form.Item label='Cuarentena por'>
                <Form.Item name='Cuarentenax' noStyle>
                  <InputNumber min={0} max={14} />
                </Form.Item>
                <span className='ant-form-text'> días</span>
              </Form.Item>
              <Form.Item label='Descanso médico por'>
                <Form.Item name='Descansox' noStyle>
                  <InputNumber min={0} max={5} />
                </Form.Item>
                <span className='ant-form-text'> días</span>
              </Form.Item>
              <Form.Item
                name='RequiereEvaluacion'
                label='Requiere evaluación'
                valuePropName='checked'
              >
                <Switch />
              </Form.Item>
              <Form.Item
                name='RestriccionAcceso'
                label='Restricción de acceso a locales'
                valuePropName='checked'
              >
                <Switch />
              </Form.Item>
              <Form.Item name='Criticidad' label='Criticidad'>
                <Slider
                  marks={{
                    0: 'Bajo',
                    20: 'Medio Bajo',
                    40: 'Medio',
                    60: 'Medio Alto',
                    80: 'Alto',
                    100: 'Critico'
                  }}
                />
              </Form.Item>
            </>
          )}

          {lecturaFicha.id != 0 && (
            <Form.Item name='Observaciones'>
              <Input.TextArea placeholder='Observaciones del medico tratante' rows={4} />
            </Form.Item>
          )}
          <div className='row'>
            <div className='col-md-12'>
              <Form.Item>
                <Button
                  loading={cargando}
                  disabled={desabilitarRegistrar()}
                  htmlType={'submit'}
                  type='primary'
                >
                  {lecturaFicha.id != 0 ? 'CALIFICAR' : 'ENVIAR'}
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Card>
    </>
  );
};

export default LecturaFicha;
